import { atom, atomFamily } from "recoil";

export interface ElementToBeShadowed {
  pageIndex: number;
  atomId: number;
  type: "Video:";
  url: string;
  widescreen?: boolean;   // NEW
}
export interface VideoPositionType { top: number; left: number; width: number; height: number }
export const VideoPlayer = atomFamily<{ height: number; width: number; vid: JSX.Element }, string>({
  key: "VS_VideoUrl",
  default: undefined,
});

export const ScrollTriggerPosition = atom<number>({
  key: "VS_ScrollTriggerPosition",
  default: 0,
});